import React from "react";
import ICONS from "./IconMap";

const InputField = ({
  type,
  placeholder,
  onClickIcon,
  onChange,
  property,
  iconName,
  maxLength,
  ...rest
}) => {
  const IconComponent = ICONS[iconName];

  //console.log(type);

  // Function to handle numeric input
  const handleNumericInput = (e) => {
    let value = e.target.value;
    // Replace any non-numeric character with an empty string
    value = value.replace(/\D/g, "");
    e.target.value = value;
    onChange(e);
  };

  const input = property ? styles[`input_${property}`] : styles.input;
  const container = property
    ? styles[`input_${property}`]
    : styles.inputContainer;

  return (
    <div style={container}>
      {iconName && <IconComponent style={styles.icon} onClick={onClickIcon} />}
      <input
        style={input}
        type={type}
        placeholder={placeholder}
        onChange={type === "tel" ? handleNumericInput : onChange} // use handleNumericInput for tel type
        {...rest}
        maxLength={maxLength}
        autoComplete="off"
      />
    </div>
  );
};

export default InputField;

const styles = {
  inputContainer: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    width: "350px",
    boxSizing: "border-box",
    //backgroundColor: "red",
  },
  input: {
    flex: 1,
    padding: "10px 10px 10px 45px",
    fontSize: "16px",
    border: "none",
    outline: "none",
    backgroundColor: "#F1F4FA",
    borderRadius: "10px",
    height: "45px",
  },
  input_editlead: {
    height: "50px",
    width: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F1F4FA",
    color: "#06152B",
    fontSize: "18px",
    borderRadius: "5px",
    flexShrink: 1,
    border: "none",
    outline: "none",
    textAlign: "center",
    fontWeight: "500",
  },
  icon: {
    position: "absolute",
    left: "10px",
    cursor: "pointer",
    fontSize: "24px",
    color: "rgba(6, 21, 43,0.5)",
  },
};
